export default "__VITE_ASSET__BNPC19mR__"